import { createContext, useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';

/**
 * Context used for telling the timeline to trigger rhumb success
 *
 * @param {function} triggerRhumbSuccess  the callback passed in that handles triggering a rhumb success in the timeline
 *
 * @callback triggerRhumbSuccess
 */

export const RhumbSuccessTriggerContext = /*#__PURE__*/createContext(emptyFunction);
export const useRhumbSuccessTriggerContext = () => useContext(RhumbSuccessTriggerContext);